import { Chip, ChipProps } from '@material-ui/core';

import { IdentityRefFragment } from '@spotify/confidence-graphql';

import { identityKind } from '../../utils';
import { IdentityAvatar } from '../IdentityAvatar';

type IdentityChipProps = ChipProps & {
  identityRef: IdentityRefFragment;
};

/** @deprecated Use IdentityChipBui instead. */
export const IdentityChip = (props: IdentityChipProps) => {
  const { identityRef, ...rest } = props;
  const isUser = identityKind(identityRef.name) === 'user';

  return (
    <Chip
      {...(isUser ? { 'data-csr-mask': true } : {})}
      avatar={<IdentityAvatar identityRef={identityRef} />}
      label={identityRef.displayName}
      {...rest}
    />
  );
};
